import React, {useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {useLocalStorage} from 'react-use';
import {
  Button,
  Col,
  Form,
  Modal,
  Row
} from "react-bootstrap";

import './style.css';

const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {

  const [auth] = useLocalStorage('authenticated');
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [roles, setRoles] = useState([]);
  //const [selectedRoleIds, setSelectedRoleIds] = useState(row?.roles?.map(role => role.ROLE_ID) ?? []);
  const [selectedRoleIds, setSelectedRoleIds] = useState(row?.roles?.map(role => role.ROLE_ID) ?? []);
  const typeaheadRef = useRef(null);

  const handleChange = async (val) => {

    const [employee, ...rest] = val;

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}users`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          EMP_ID: employee.EMP_ID
        }
      }
    );

    const data = response.data.items;

    if (response.data.items[0]) {
      typeaheadRef.current.clear();
      return alert('User already exists!');
    }


    onChange({
      target: {
        name: `EMP_ID`,
        value: employee.EMP_ID
      }
    });

    setEmployees([employee]);

  }

  const handleSearch = async (value) => {

    if (!value) return;

    try {

      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}employees`,
        {
          headers: {Authorization: `Bearer ${auth.token}`},
          params: {
            search: value,
          },
        }
      );

      setOptions(response.data.items);
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleSubmit = async (event) => {
    if (selectedRoleIds.length === 0){
      alert('Please select role user!');
      event.preventDefault();
      event.stopPropagation();
      return;
    }else if(typeaheadRef.current?.inputNode?.defaultValue === null || typeaheadRef.current?.inputNode?.defaultValue === ''){
      alert('Please choose employee!');
      event.preventDefault();
      event.stopPropagation();
    }else{
      onChange({
        target: {
          name: 'roleIds',
          value: selectedRoleIds,
        }
      });

      setTimeout(onApplyChanges, 1000);
    }
  };

  useEffect(() => {
  if (row?.roles) {
    setSelectedRoleIds(row.roles.map(role => role.ROLE_ID));
  }
}, [row.roles]);



  const handleChangeRole = (event, role) => {
    if (event.target.checked && !selectedRoleIds.includes(role.ROLE_ID)) {
      setSelectedRoleIds(s => {
        const n = [...s, role.ROLE_ID]
        onChange({
          target: {
            name: 'roleIds',
            value: n,
          }
        });
        return n;
      })
    } else if (!event.target.checked) {
      setSelectedRoleIds(s => {
        const n = s.filter(item => item != role.ROLE_ID);
        onChange({
          target: {
            name: 'roleIds',
            value: n,
          }
        });
        return n;
      });
    }
  }

  const fetchRoles = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}roles`,
      {headers: {Authorization: `Bearer ${auth.token}`}}
    );

    setRoles(response.data.items);
  }

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    onChange({
      target: {
        name: 'roleIds',
        value: selectedRoleIds,
      }
    })
  }, [selectedRoleIds]);

  if (!open) return null;

  return (
    <Modal
      show={open}
      onHide={() => {
        setEmployees([]);
        onCancelChanges();
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>User Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {!row.employee && (
            <Form.Group>
              <Form.Label>Employee</Form.Label>
              <AsyncTypeahead
                filterBy={() => true}
                id="async-example"
                isLoading={isLoading}
                labelKey="EMP_NAME"
                minLength={1}
                onChange={handleChange}
                onSearch={handleSearch}
                options={options}
                placeholder={`Please select only one employee`}
                renderMenuItemChildren={({EMP_NAME, EMP_EMAIL}) => (
                  <div>
                    {EMP_NAME}
                    <div>
                      <small>{EMP_EMAIL}</small>
                    </div>
                  </div>
                )}
                ref={typeaheadRef}
                inputProps={{ required: true }}
              />
            </Form.Group>
          )}
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <p>{row.employee?.EMP_NAME || [...employees].pop()?.EMP_NAME }</p>
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <p>{row.employee?.EMP_EMAIL || [...employees].pop()?.EMP_EMAIL }</p>
          </Form.Group>
          {row?.USER_ID && (
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Check
                id="custom-switch-11"
                name="USER_STATUS"
                type="switch"
                className="mb-1"
                defaultChecked={row.USER_STATUS}
                onChange={e => {
                  e.target.value = e.target.checked ? 1 : 0;
                  onChange(e);
                }}
              />
            </Form.Group>
          )}
          <Form.Group>
            <Form.Label>Role</Form.Label>
            <Row>
              {roles && roles.map((role, key) => (
                <Col md={6} key={key}>
                  <Form.Check
                    inline
                    name="roleIds"
                    label={role.ROLE_NAME}
                    checked={selectedRoleIds.includes(role.ROLE_ID)}
                    //defaultChecked={row.roles?.some((item) => item.ROLE_ID === role.ROLE_ID)}
                    type="checkbox"
                    onChange={(event) => handleChangeRole(event, role)}
                    id={`inline-admin-${key}`}
                  />
                </Col>
              ))}
            </Row>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => {
          onCancelChanges();
          setEmployees([]);
        }}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>Save</Button>
      </Modal.Footer>
    </Modal>
  )
};

export default Popup;